/* eslint-disable @typescript-eslint/no-misused-promises, no-void */
import React, { useEffect } from "react";
import useHeaderStore from "../../../../store/layout/headerStore";
import AccountSettingsPage from "./AccountSettingsPage";
import SecuritySettingsPage from "./SecuritySettingsPage";

type TabValue = "account" | "security";

type Props = {
  initialTab?: TabValue;
};

const AccountSettingsHubPage: React.FC<Props> = ({ initialTab = "account" }) => {
  const { setHeaderContent, resetHeader } = useHeaderStore();

  useEffect(() => {
    resetHeader();
    setHeaderContent({
      title: initialTab === "account" ? "My Profile" : "Security",
      description:
        initialTab === "account"
          ? "Manage your personal information and preferences"
          : "Manage your password and security settings",
    });

    return () => resetHeader();
  }, [initialTab, resetHeader, setHeaderContent]);

  return (
    <div className="mx-auto max-w-5xl px-4 py-4">
      {initialTab === "account" ? <AccountSettingsPage embedded /> : <SecuritySettingsPage embedded />}
    </div>
  );
};

export default AccountSettingsHubPage;
